// pdf-sidebar.builder.ts
import htmlToPdfmake from 'html-to-pdfmake';

export class PdfSidebarBuilder {
  sidebarCount = 0;
  sidebarActive = false;

  processSidebarSection(section: any, currentLanguage: string): any[] {
    this.sidebarCount++;
    const translation = section.translations[currentLanguage];
    if (!translation || translation.title !== 'Sidebar') {
      return [];
    }

    let sidebarText = '';
    section.editor_blocks.forEach((block: any) => {
      const blockTranslation = block.translations[currentLanguage];
      if (blockTranslation && blockTranslation.content_rendered) {
        blockTranslation.content_rendered.forEach((contentBlock: any) => {
          if (contentBlock.type === 'paragraph') {
            sidebarText += contentBlock.data.text + '\n';
          }
        });
      }
    });

    let sidebarBackground: any;
    // Passe die Breite u. pageBreak-Eigenschaft je nach Sidebar-Zähler an
    if (this.sidebarCount > 1) {
      sidebarBackground = {
        canvas: [
          {
            type: 'rect',
            x: 0,
            y: 0,
            w: 130,
            h: 842,
            color: '#F4F2F1'
          }
        ],
        absolutePosition: { x: 0, y: 0 },
      };
    } else {
      sidebarBackground = {
        canvas: [
          {
            type: 'rect',
            x: 0,
            y: 0,
            w: 130,
            h: 842,
            color: '#F4F2F1'
          }
        ],
        absolutePosition: { x: 0, y: 0 }
      };
    }

    const sidebarTextElement = {
      absolutePosition: { x: 10, y: 80 },
      text: htmlToPdfmake(sidebarText),
      fontSize: 6,
      width: 120
    };

    this.sidebarActive = true;
    return [sidebarBackground, sidebarTextElement];
  }
}
